import { lazy, Suspense } from "react";
import type { DevicePoint, MetricPoint, UsagePoint, WeeklyNewVsCancelled } from "@apphq/shared/types";
import { LoadingState } from "./ui";

const Mrr = lazy(() => import("./charts").then((m) => ({ default: m.MrrChart })));
const Device = lazy(() => import("./charts").then((m) => ({ default: m.DeviceChart })));
const Usage = lazy(() => import("./charts").then((m) => ({ default: m.UsageChart })));
const Rating = lazy(() => import("./charts").then((m) => ({ default: m.RatingChart })));
const Weekly = lazy(() => import("./charts").then((m) => ({ default: m.WeeklyBars })));

export function MrrChart(props: { points: MetricPoint[]; label?: string; height?: number }) {
  return (
    <Suspense fallback={<LoadingState label="Grafiek laden…" />}>
      <Mrr {...props} />
    </Suspense>
  );
}

export function WeeklyBars(props: { rows: WeeklyNewVsCancelled[] }) {
  return (
    <Suspense fallback={<LoadingState label="Grafiek laden…" />}>
      <Weekly {...props} />
    </Suspense>
  );
}

export function DeviceChart(props: { points: DevicePoint[]; height?: number }) {
  return (
    <Suspense fallback={<LoadingState label="Grafiek laden…" />}>
      <Device {...props} />
    </Suspense>
  );
}

export function UsageChart(props: { points: UsagePoint[]; height?: number }) {
  return (
    <Suspense fallback={<LoadingState label="Grafiek laden…" />}>
      <Usage {...props} />
    </Suspense>
  );
}

export function RatingChart(props: { points: MetricPoint[]; height?: number }) {
  return (
    <Suspense fallback={<LoadingState label="Grafiek laden…" />}>
      <Rating {...props} />
    </Suspense>
  );
}
